import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a4d182e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "s-canvas" }
const _hoisted_2 = ["width", "height"]

import { onMounted, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'iDentify',
  props: {
    identifyCode: {
        type: String,
        default: '1234'
    },
    fontSizeMin: {
        type: Number,
        default: 35
    },
    fontSizeMax: {
        type: Number,
        default: 35
    },
    backgroundColorMin: {
        type: Number,
        default: 180
    },
    backgroundColorMax: {
        type: Number,
        default: 240
    },
    colorMin: {
        type: Number,
        default: 50
    },
    colorMax: {
        type: Number,
        default: 160
    },
    lineColorMin: {
        type: Number,
        default: 40
    },
    lineColorMax: {
        type: Number,
        default: 180
    },
    dotColorMin: {
        type: Number,
        default: 0
    },
    dotColorMax: {
        type: Number,
        default: 255
    },
    contentWidth: {
        type: Number,
        default: 105
    },
    contentHeight: {
        type: Number,
        default: 40
    }
},
  setup(__props) {

const props = __props



const randomNum = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min)
};

const randomColor = (min, max) => {
    let r = randomNum(min, max)
    let g = randomNum(min, max)
    let b = randomNum(min, max)
    return 'rgb(' + r + ',' + g + ',' + b + ')'
};

const drawLine = (ctx) => {
    for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = randomColor(props.lineColorMin, props.lineColorMax)
        ctx.beginPath()
        ctx.moveTo(randomNum(0, props.contentWidth), randomNum(0, props.contentHeight))
        ctx.lineTo(randomNum(0, props.contentWidth), randomNum(0, props.contentHeight))
        ctx.stroke()
    }
};
 
const drawText = (ctx, txt, i) => {
    ctx.fillStyle = randomColor(props.colorMin, props.colorMax)
    ctx.font = randomNum(props.fontSizeMin, props.fontSizeMax) + 'px SimHei'
    let x = (i + 1) * (props.contentWidth / (props.identifyCode.length + 1))-11
    let y = randomNum(props.fontSizeMax, props.contentHeight - 5)
    var deg = randomNum(-15, 15)
    ctx.translate(x, y)
    ctx.rotate(deg * Math.PI / 180)
    ctx.fillText(txt, 0, 0)
    ctx.rotate(-deg * Math.PI / 180)
    ctx.translate(-x, -y)
};
 
const drawDot = (ctx) => {
    for (let i = 0; i < 30; i++) {
        ctx.fillStyle = randomColor(0, 255)
        ctx.beginPath()
        ctx.arc(randomNum(0, props.contentWidth), randomNum(0, props.contentHeight), 1, 0, 2 * Math.PI)
        ctx.fill()
    }
};
 
const drawPic = () => {
    let canvas = document.getElementById('s-canvas') as HTMLCanvasElement;
    let ctx = canvas.getContext('2d');
    ctx.textBaseline = 'bottom';
    ctx.fillStyle = randomColor(props.backgroundColorMin, props.backgroundColorMax);
    ctx.fillRect(0, 0, props.contentWidth, props.contentHeight);
    const cd=Number(props.identifyCode.length);
    for(let i = 0; i < cd; i++){
        drawText(ctx, props.identifyCode[i], i)
    }
    drawLine(ctx);
    drawDot(ctx);
};
watch(() => props.identifyCode, () => {
     drawPic()
})
onMounted(() => {
   drawPic()
}) 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", {
      id: "s-canvas",
      width: props.contentWidth,
      height: props.contentHeight
    }, null, 8, _hoisted_2)
  ]))
}
}

})